<template>
  <ion-header>
    <ion-toolbar>
      <ion-buttons slot="start">
        <ion-button @click="cerrarModal();">
          <ion-icon slot="icon-only"  name="arrow-back-outline"></ion-icon>
        </ion-button>
      </ion-buttons>
      <ion-title>BUSCAR USUARIO</ion-title>
    </ion-toolbar>
  </ion-header>

  <ion-content>
    <ion-grid v-if="cargando" class="ion-text-center ion-margin-top ion-padding-top">
      <ion-row class="ion-justify-content-center ion-margin-top ion-padding-top">
        <ion-col size="12">
          <ion-spinner name="lines" style="width:80px; height:80px;"></ion-spinner>
        </ion-col>
        <ion-col size="12">
          <ion-label color="dark">CARGANDO...</ion-label>
        </ion-col>
      </ion-row>
    </ion-grid>

    <ion-list v-else>
      <ion-item class="mt-1">
        <div class="container-fluid p-0">
          <div class="row">
            <div class="col-12">
              <h6>PERSONAS SELECCIONADAS:</h6>
            </div>
            <div v-if="usrSeleccionados.length > 0" class="col-12">
              <div class="border rounded-pill pt-1 pb-2 px-2 mb-2" style="display:inline-flex;" v-for="(usuario,index) in usrSeleccionados" :key="'usr'+index">
                <span><span style="font-size:11px!important;">{{usuario.nombre}}</span><span @click="usrSeleccionados.splice(index,1);"><fa :icon="['fad', 'times']" class="fa-fw ml-2" style="cursor:pointer;"></fa> </span></span>
              </div>
            </div>
            <h6 v-else class="col-12 text-secondary text-center my-3">SIN PERSONAS SELECCIONADAS.</h6>
          </div>
        </div>
      </ion-item>

      <ion-item class="mt-3">
        <div class="container-fluid p-0">
          <div class="row">
            <div class="col-12">
              <h6>BUSCAR PERSONA (nombre/apellido/rut)</h6>
            </div>
            <div class="col-6 pl-5">
              <ion-input type="text" slot="start" placeholder="juanito" v-model="filtro"></ion-input>
            </div>
            <div class="col-6 text-right">
              <ion-button :disabled="filtro==''" @click="buscarUsuarios();" shape="round"><fa :icon="['fad', 'plus']" class="fa-fw mr-1"></fa>BUSCAR</ion-button>
            </div>
          </div>
        </div>
      </ion-item>

      <div class="container-fluid mt-3 p-0">
        <div class="row">
          <div class="col-12">
            <h6 class="ml-3">PERSONAS ENCONTRADAS:</h6>
          </div>
        </div>
        <div v-if="usuarios.length==0" class="row">    
          <div class="col-12">
            <h6 class="text-secondary text-center mt-3">SIN RESULTADOS.</h6>
          </div>
        </div>
        <div class="row">    
          <div class="col-12">
            <ion-list lines="full">

              <ion-item v-for="usuario in usuarios" :key="usuario.rut" class="mt-2">
                <div class="container-fluid p-0">
                  <div class="row">
                    <div class="col-8">
                      <div class="container-fluid p-0">
                        <div class="row">
                          <div style="font-size=10px!important;" class="col-12">
                            <h6>{{usuario.nombre}}</h6>
                          </div>
                          <div class="col-12">
                            <h6 class="text-secondary">{{new Intl.NumberFormat('esp-CL').format(usuario.rut)}}-{{usuario.dv}}</h6>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-4 text-right">
                      <ion-button :disabled="usrSeleccionados.indexOf(usuario) != -1" @click="usrSeleccionados.push(usuario)" shape="round" size="default" color="warning" ><fa :icon="['fad', 'plus']" class="fa-fw"></fa></ion-button>
                    </div>
                  </div>
                </div>
              </ion-item>

            </ion-list>
          </div>
        </div>
      </div>
      
    </ion-list>
  </ion-content>

  <ion-footer>
    <ion-grid>
      <ion-row>
        <ion-col>
            <ion-button @click="cerrarModal()" color="danger" shape="round" expand="block">
                <ion-label>CERRAR</ion-label>
            </ion-button>
        </ion-col>
        <ion-col>
            <ion-button :disabled="!validaDatos()" @click="cerrarModal({usuarios: usrSeleccionados});" color="success" shape="round" expand="block">
                <ion-label>ACEPTAR</ion-label>
            </ion-button>
        </ion-col>
      </ion-row>
    </ion-grid>
  </ion-footer>
</template>

<script>
import { modalController, IonContent, IonFooter, IonHeader, IonTitle, IonToolbar, IonButtons, IonButton, IonIcon, IonCol, IonRow, IonGrid, 
      IonLabel, IonItem, IonInput, IonSpinner, IonList, toastController } from '@ionic/vue';
import { defineComponent } from 'vue';
import { Preferences     } from '@capacitor/preferences';
import { cerrarSesion    } from '@/plugins/funciones';
import axios               from 'axios';
import rutaBase            from '@/plugins/variables';

export default defineComponent({
  name: 'ModalBuscarUsuario',
  props: {
    seleccionados: Array
  },
  components: { IonContent, IonFooter, IonHeader, IonTitle, IonToolbar, IonButtons, IonButton, IonIcon, IonCol, IonRow, IonGrid, IonLabel, 
  IonItem, IonInput, IonSpinner, IonList },
  data(){
    const arreglo = [];
    return {
      cargando          : false,
      usuarios          : [],
      usrSeleccionados  : arreglo,
      filtro            : ''
    }
  },
  created(){
    if(this.seleccionados){
      this.seleccionados.forEach(usr => {
        this.usrSeleccionados.push(usr);
      });
    }
  },
  methods:{
    async buscarUsuarios(){
      this.cargando = true;
      const token   = await Preferences.get({ key: 'token_auth' });
      const headers = { headers: { 'Authorization': `${token.value}` } };
      const dato    = new URLSearchParams();
      dato.append('filtro', this.filtro);
      axios.post(rutaBase+'/turnos/buscarUsuarios', dato, headers).then( resp => {
        if(resp.status == 203) { cerrarSesion(); }
        this.cargando = false;
        this.usuarios = resp.data;
      }).catch(() =>{
        this.cargando = false;
        this.muestraToast('ERROR AL REALIZAR LA BUSQUEDA.');
      });
    },

    validaDatos(){
      if(
        this.usrSeleccionados.length == 0
      ){
        return false;
      }
      else {
        return true;
      }
    },

    async cerrarModal(dato={recargar:false}){
      modalController.dismiss(dato);
    },

    async muestraToast(msj='') {
      const toast = await toastController
        .create({
          message: msj,
          duration: 2000,
          cssClass: 'text-center'
        })
      return toast.present();
    }
  }
});
</script>

<style>
.alert-wrapper.sc-ion-alert-md {
  min-width:350px !important;
  max-width:none !important;
}
</style>